import { render, staticRenderFns } from "./CalendarView.vue?vue&type=template&id=528c420e&"
import script from "./CalendarView.vue?vue&type=script&lang=js&"
export * from "./CalendarView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports